import { useEffect, useState } from 'react'
import { LocaleEnum } from '@systemeio/ui-frontend'
import { useRouter } from 'next/router'
import useUser from 'shared/hooks/use-user'
import { buildDashboardUrl } from 'modules/white-label/utils/dashboard-url'

export const useGetLoginUrl = (): string => {
  const { locale, defaultLocale, asPath, isReady } = useRouter()
  const { user } = useUser()
  const currentLocale = user?.dashboardLocale || locale || defaultLocale || LocaleEnum.ENGLISH
  const [loginUrl, setLoginUrl] = useState(`/${currentLocale}/login`)

  useEffect(() => {
    if (!isReady) return
    const origin = globalThis.location.origin
    const fullCurrentUrl = `${origin}${asPath}`
    const encodedRedirect = encodeURIComponent(fullCurrentUrl)
    const url = `/${currentLocale}/login?redirectUrl=${encodedRedirect}`
    setLoginUrl(prev => (prev !== url ? url : prev))
  }, [asPath, currentLocale, isReady])

  return loginUrl
}

export const getContactUrl = (contactId: string): string =>
  buildDashboardUrl(`/dashboard/contacts/${contactId}`)
